import { connect } from 'react-redux'
import { ComponentWithPermissions } from '../../../../../../baseComponents/CreateRoutering/types'
import { BaseScreenTableSimpleStateless, useBaseScreenTableLogic } from '../../../../../../baseComponents/TwinTable/BaseScreenTable'
import withLoading from '../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { EmployeesPayload } from '../../../../../../utils/reducers/company/employees'
import ModalCreateCustomer from './ModalCreateCustomer'
import TableAllCustomers from '../../../../../../specificComponents/Customers/TableAllCustomers'
import useUpdateTableInstance from '../../../../../../utils/hooks/useUpdateTableInstance'
import RightHeaderTableCustomers from '../../../../../../specificComponents/Customers/RightHeaderTableCustomers'
import './allCustomers.sass'

interface AllCustomersProps extends ComponentWithPermissions { }

const AllCustomers: React.FC<AllCustomersProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const { openModal, setOpenModal, tableInstance, setTableInstance } = useBaseScreenTableLogic()
    const { updateTableInstance } = useUpdateTableInstance({ tableInstance })
    const pageData = {
        title: t('customers', 'Clientes'),
        newText: t('newCustomer', 'Nuevo cliente'),
    }

    return (
        <BaseScreenTableSimpleStateless TableComponent={TableAllCustomersConnect} {...{ pageData, userPermissions, updateTableInstance }} CreateModalComponent={ModalCreateCustomer} logicProps={{ openModal, setOpenModal, tableInstance, setTableInstance }} RightHeader={
        <RightHeaderTableCustomers {...{ pageData, openModal, setOpenModal, userPermissions, updateTableInstance }} />}/>
    )
}

const tableAllCustomersDispatch = {
    setEmployees: (payload: EmployeesPayload) => ({ type: 'CHANGE_EMPLOYEE', payload }),
}

const mapTableAllCustomersConnector = (state: AllReduxPayloads) => ({ employees: state.employees })
const tableAllCustomersConnect = connect(mapTableAllCustomersConnector, tableAllCustomersDispatch)
const tableAllCustomersLoading = withLoading(TableAllCustomers, [{ fetchUrl: '/api/app/employee/getAllEmployees', propName: 'employees', setFunctionName: 'setEmployees' }])
const TableAllCustomersConnect = tableAllCustomersConnect(tableAllCustomersLoading)
export default AllCustomers